import { render, staticRenderFns } from "./DrugsTable.vue?vue&type=template&id=191ee525&"
import script from "./DrugsTable.vue?vue&type=script&lang=js&"
export * from "./DrugsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports